// components/common/CooldownTimer.jsx
import React, { useState, useEffect } from 'react';

const CooldownTimer = ({ startDate, daysLimit = 3, lang = 'es' }) => {
  const [message, setMessage] = useState(null);

  useEffect(() => {
    if (!startDate) return;

    const updateTimer = () => {
      const start = new Date(startDate);
      const target = new Date(
        start.getTime() + daysLimit * 24 * 60 * 60 * 1000
      );

      const now = new Date();
      const diff = target.getTime() - now.getTime();

      if (diff <= 0) {
        setMessage(null);
        return;
      }

      const days = Math.ceil(diff / (1000 * 60 * 60 * 24));

      if (lang === 'en') {
        if (days === 1) {
          setMessage('Your next oracle reading will be available tomorrow.');
        } else {
          setMessage(
            `Your next oracle reading will be available in ${days} days.`
          );
        }
      } else {
        if (days === 1) {
          setMessage('Tu próxima lectura estará disponible mañana.');
        } else {
          setMessage(
            `Tu próxima lectura estará disponible en ${days} días.`
          );
        }
      }
    };

    updateTimer(); // Ejecuta inmediatamente

    const interval = setInterval(updateTimer, 60000);

    return () => clearInterval(interval);
  }, [startDate, daysLimit, lang]);

  if (!message) return null;

  return (
    <p className="text-amber-500 text-sm font-bold text-center animate-pulse">
      {message}
    </p>
  );
};

export default CooldownTimer;